<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import { GetDataMethods, PostDataMethods } from "@/state/helpers";

/**
 * Orders Component
 */
export default {
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            title: "Withdrawals",
            items: [
                {
                    text: "Wesal",
                },
                {
                    text: "withdrawals",
                },
            ],
            isVisible: false,
            countPage: 1,
            paymentsData: [],
            currentPage: 0,
            perPage: 10,
            filter: "",
            fields: [
                { key: "id", sortable: true, label: "ID" },
                { key: "point", sortable: false, label: "Withdrawn Points" },
                { key: "point_now", sortable: false, label: "Current Points" },
                { key: "user_id", sortable: false, label: "User ID" },
                { key: "order_id", sortable: false, label: "Order Id" },
                { key: "user_id", sortable: false, label: "User Id" },
                { key: "action_id", sortable: false, label: "Action Id" },
                { key: "withdrawal_by", sortable: false, label: "Withdrawal By" },
                { key: "created_at", sortable: false, label: "Created At" },
                //{ key: "updated_at", sortable: false, label: "Updated At" },
            ],
        };
    },
    computed: {
        /**
         * Total no. of records
         *
         */
        rows() {
            return this.countPage
        }

    },

    mounted() {
        this.GetUsersData();
    },



    watch: {
        currentPage: function () {
            this.GetUsersData();
        },
    },


    methods: {
        ...GetDataMethods,
        ...PostDataMethods,

        async GetUsersData() {
            let url = `get_withdrawals`
            if (this.currentPage) {
                url += `?page=${this.currentPage}`
            }
            const res = await this.getData(url);
            this.paymentsData = res.data.data.data;
            this.countPage = res.data.data.total;
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0">
                        <!-- <div class="row mt-4"> -->
                        <!-- Search -->
                        <!-- <div class="col-sm-12 col-md-6">
                                        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                            <label class="d-inline-flex align-items-center">
                                                Search:
                                                <b-form-input v-model="filter" type="search" placeholder="Search..."
                                                    class="form-control form-control-sm ml-2"></b-form-input>
                                            </label>
                                        </div>
                                    </div> -->
                        <!-- End search -->
                        <!-- </div> -->
                        <div class="table-responsive">
                            <b-table class="table-centered" :items="paymentsData" :fields="fields"
                                responsive="sm" :filter="filter" :per-page="perPage">

                                <template v-slot:cell(top_up_id)="data">
                                    <div>{{ data.value = null }}</div>
                                </template>

                                <template v-slot:cell(updated_at)="data">
                                    <div>{{ data.value | formatDate }}</div>
                                </template>
                                <template v-slot:cell(created_at)="data">
                                    <div>{{ data.value | formatDate }}</div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :totalRows="rows" :per-page="perPage"
                                            aria-controls="user-tab">
                                        </b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
